// extracted by mini-css-extract-plugin
module.exports = {"headerWrapper":"styles_headerWrapper__tJpvy"};